import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/gua";

export default function TestimonialSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="relative h-64 w-full overflow-hidden rounded-2xl bg-background-200 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20a%20cozy%20reading%20corner%20with%20stacked%20magazines%20and%20a%20glowing%20desk%20lamp%2C%20muted%20amber%20and%20cream%20tones%2C%20grainy%20retro%20poster%20texture&width=900&height=700&seq=gua-brand-about&orientation=landscape"
              alt="蝌蚪吃瓜 内容整理工作场景插画"
              title="蝌蚪吃瓜 - 内容整理与合集维护"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div>
            <SectionHeading
              eyebrow="关于蝌蚪吃瓜"
              title="我们只做一件事：把瓜讲完整"
              desc="不抢第一时间，也不靠拼接片段制造话题。我们把公开信息按时间线整理成合集，区分「已确认」与「流传版本」，让你看完之后对一件事有完整判断。"
            />
            <ul className="mt-6 flex flex-col gap-3">
              {[
                "每条内容标注时间线与关键节点",
                "区分已确认信息与流传版本，不做混淆",
                "合集长期维护，可反复回看并看到后续补充",
                "内容仅围绕公开话题整理，不涉及个人隐私",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {t}
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-16">
          <SectionHeading title="读者怎么说" align="center" />
          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t, idx) => (
              <figure
                key={t.name}
                className={`flex flex-col rounded-xl border p-6 ${
                  idx === 1
                    ? "border-secondary-200 bg-secondary-50"
                    : "border-background-200 bg-background-50"
                }`}
              >
                <i className="ri-double-quotes-l text-2xl text-primary-400"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {t.text}
                </blockquote>
                <figcaption className="mt-4 border-t border-background-200 pt-3">
                  <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                  <span className="text-xs text-foreground-500">{t.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}